<template>
  <div class="row my-1 align-items-center info-box">
    <div class="col-20 col-md-6 sep">
      <span class="label">
        {{ $t('view-Payments.info.to_pay') }}
      </span>
      <box-value
        :list="toPay"
        not-empty-class="text-danger"
      />
    </div>
    <div class="col-20 col-md-7 sep">
      <span class="label">
        {{ $t('view-Payments.info.in_progress_count') }}
      </span>
      <span class="value">
        {{ inProgressCount }}
      </span>
    </div>
    <div class="col-20 col-md-7">
      <span class="label">
        {{ $t('view-Payments.info.cache_to_returned') }}
      </span>
      <box-value
        :list="toReturned"
        not-empty-class="text-success"
      />
    </div>
  </div>
</template>

<script>
import boxValue from './InfoBoxValues.vue'

export default {
  components: {
    'box-value': boxValue
  },
  computed: {
    inProgressCount () {
      return this.$store.state.payments.items.filter(i => i.status === 'in_progress' || i.status === 'new').length
    },
    toReturned () {
      return this.$store.state.payments.items.filter(i => i.type === 'campaign_overpay_return' && (i.status === 'in_progress' || i.status === 'new'))
    },
    toPay () {
      return this.$store.state.payments.items.filter(i => i.type === 'campaign' && i.status === 'new')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
